import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { NavController } from '@ionic/angular';
import { UserGuideService } from 'src/app/services/user-guide.service';

@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent implements OnInit {
  shouldShowScrollFloatHint: boolean = false;
  @ViewChild('wrapComponent') wrapComponent!: ElementRef;

  constructor(
    private readonly navCtrl: NavController,
    private readonly userGuideService: UserGuideService
  ) {}

  ngOnInit() {
    return;
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.shouldShowScrollFloatHint =
        this.userGuideService.scrollFloatHintShouldAppear(
          this.wrapComponent?.nativeElement
        );
    }, 300);
  }

  onContinue(): void {
    this.navCtrl.navigateRoot('scan');
  }

  scrollPageToBottom(target: HTMLElement): void {
    target.scrollTo({ top: target.clientHeight, behavior: 'smooth' });
  }
}
